var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconList = function SvgIconList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.75 6.818a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M9.75 6.818a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5zM9.75 11.318a.75.75 0 1 0 0 1.5h7.5a.75.75 0 0 0 0-1.5zM9 16.568a.75.75 0 0 1 .75-.75h7.5a.75.75 0 1 1 0 1.5h-7.5a.75.75 0 0 1-.75-.75M6 12.068a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0M6.75 15.818a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5"
  })));
};
export default SvgIconList;